export const QUESTION_LEVELS = [
  { value: '', label: '未定义', color: '#909399' },
  { value: '红题', label: '红题', color: '#F56C6C' },
  { value: '橙题', label: '橙题', color: '#E6A23C' },
  { value: '黄题', label: '黄题', color: '#F7BA2A' },
  { value: '绿题', label: '绿题', color: '#67C23A' },
  { value: '蓝题', label: '蓝题', color: '#409EFF' },
  { value: '紫题', label: '紫题', color: '#9B59B6' },
  { value: '黑题', label: '黑题', color: '#2C3E50' }
]

export const getQuestionLevelStyle = (level) => {
  const levelConfig = QUESTION_LEVELS.find(item => item.value === level) || QUESTION_LEVELS[0]
  return {
    backgroundColor: levelConfig.color,
    color: '#FFFFFF',
    padding: '0 8px',
    borderRadius: '4px',
    fontSize: '12px',
    display: 'inline-block',
    height: '28px',
    lineHeight: '28px'
  }
} 